import * as React from 'react';

const PosterPersonTitle = (props: { fullName: string }) => (
    <div className={'poster-child-name-container'}>
        <h3 className={'child-name-title'}>{props.fullName}</h3>
    </div>
)

export default PosterPersonTitle;


// WEBPACK FOOTER //
// ./src/modules/Case/InformationView/components/PosterPrint/components/PosterPersonTitle.tsx